import {
    Application,
    ApplicationCategory,
    ApplicationStatus,
} from '../types';

export type FormValues = Application;

// FNP-1498: the CREATE path gets the same defaults the edit path gets.
//
// ⚠️ THE EARLY RETURN USED TO SKIP THEM, and that becomes a bug the moment
// the create form stops asking for category and status. Both are required by
// RecordSchema (FNP-279 and FNP-47), so a create would fail validation with no
// field on screen to fix — an unfixable error, which is worse than a missing
// one.
//
// Defaults are applied to genuinely empty values only, so a live status like
// CREATING or FAILED is never clobbered on edit. That was the original reason
// for this function: records predating either rule arrived empty and blocked
// even a description-only change, with the error hidden below the fold.
//
// ⚠️ `provisionAutomatically` is GONE. It was a form-only flag gating the
// provisioning fieldset, and provisioning is now its own act with its own form
// (FNP-1500). A create no longer forces applicationStatus to CREATING; a record
// is ACTIVE from the start because it describes an application, not a build.
export const buildInitialValues = (record?: Application): FormValues => {
    const defaults = {
        applicationCategory: ApplicationCategory.BUSINESS,
        applicationStatus: ApplicationStatus.ACTIVE,
    } as FormValues;

    if (!record) {
        return defaults;
    }

    return {
        ...defaults,
        ...record,
        applicationCategory: record.applicationCategory || ApplicationCategory.BUSINESS,
        applicationStatus: record.applicationStatus || ApplicationStatus.ACTIVE,
    };
};
